<template>
  <client-only>
    <v-row align-items="center">
      <v-col
        v-for="(item, ind) in chunckedGooddies"
        :key="ind"
        cols="6"
        xl="3"
        lg="3"
        md="3"
        xs="6"
        sm="6"
        class="py-1 px-1"
      >
        <p class="full-item-wrapper py-1 display-16 mb-0">
          <span class="d-inline-flex">
            <client-only>
              <v-img
                class="ml-2 gooddies-icons"
                :src="
                  require(`@/assets/img/company_page/icons/icon${item.Id}.png`)
                "
                max-width="35"
              />
            </client-only>
          </span>

          <span class="d-inline-flex">{{ item.Name }}</span>
        </p>
      </v-col>
      <v-col v-if="CustomBenefit" class="py-1 px-1">
        <p class="full-item-wrapper py-1 display-16 mb-0">
          <span class="d-inline-flex">
            <client-only>
              <v-img
                class="ml-2 gooddies-icons"
                :src="require(`@/assets/img/company_page/icons/icon${30}.png`)"
                max-width="35"
              />
            </client-only>
          </span>

          <span class="d-inline-flex">{{ CustomBenefit }}</span>
        </p>
      </v-col>
    </v-row>
  </client-only>
</template>

<script>
export default {
  props: {
    benefits: {
      type: Array,
    },
    CustomBenefit: {
      type: String,
    },
  },
  data() {
    return {
      goodiesIcons: {
        1: 'schedule',
        2: 'home',
        3: 'check_circle',
        4: 'pie_chart',
        5: 'check_circle',
        6: 'check_circle',
        7: 'beach_access',
        8: 'local_cafe',
        9: 'restaurant',
        10: 'videogame_asset',
        11: 'emoji_events',
        12: 'restaurant_menu',
        13: 'check_circle',
        14: 'check_circle',
        15: 'palette',
        16: 'school',
        17: 'fitness_center',
        18: 'check_circle',
        19: 'sports_baseball',
        20: 'check_circle',
        21: 'pets',
        22: 'local_parking',
        23: 'fastfood',
        24: 'check_circle',
        25: 'check_circle',
        26: 'pool',
        27: 'local_bar',
        28: 'local_dining',
        29: 'train',
        30: 'grade',
        31: 'check_circle',
      },
    };
  },

  computed: {
    chunckedGooddies() {
      let tempGooddies = this.benefits;
      return tempGooddies;
    },

    chunckedGooddiesForMobile() {
      let tempGooddies = this.benefits;
      return tempGooddies;
    },
  },
};
</script>

<style lang="scss" scoped>
.full-item-wrapper {
  font-size: 14px;
  color: black;
  line-height: 1.4;
  letter-spacing: -0.6px;
  text-align: right;
  display: flex;
  align-items: center;
  .gooddies-icons {
    filter: 
      invert(45%) 
      sepia(100%) 
      saturate(1726%) 
      hue-rotate(359deg) 
      brightness(100%) 
      contrast(107%);
  }
}
</style>
